import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref, ref, watch } from 'vue';
import { removeBodyScroll } from '@/modules/common/helpers/browser';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  NavBar,
  HelperViewContextual,
  HeadingDisplay,
  InitialAvatarIcon,
  Heading,
  BaseText,
  Row,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';
import { PasswordModal } from '@/modules/trade/components/PasswordModal';

import {
  updateTraderShield,
  IMarginAllocationV2
} from '@/modules/trade/services/margin-allocation';

interface EmitEvents {
  (event: 'close'): void;
}
interface Props {
  isOpen: boolean;
  editMode: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TraderShield',
  props: {
    isOpen: { type: Boolean },
    editMode: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
  editMode: boolean;
};





const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocationV2>;
const fetchMarginAllocation = inject('fetchMarginAllocation', async () => ({}));

const isLoading = ref(false);
const isPasswordModalOpen = ref(false);

const helperViewClass = computed(() => {
  return props.editMode
    ? 'trader-shield__helper edit-mode'
    : 'trader-shield__helper';
});

const title = computed(() => {
  return props.editMode
    ? 'Para editar ou desalocar, desative o Trader Shield'
    : 'Trader Shield ativo';
});

const description = computed(() => {
  return props.editMode
    ? 'Seu limite está protegido. Desative o Trader Shield para editar ou desalocar.'
    : 'Uma camada extra de proteção para o seu patrimônio, desenvolvida pela Warren.';
});

const traderShieldDetails = computed(
  () => marginAllocation.value.traderShieldDetails
);

function confirmPassword() {
  isPasswordModalOpen.value = false;
  handleTraderShield();
}

async function handleTraderShield() {
  try {
    isLoading.value = true;

    const { isTraderShieldEnabled } = await updateTraderShield(
      marginAllocation.value!.accountId
    );

    await fetchMarginAllocation();

    notify({
      group: 'wrn-notifications',
      text: isTraderShieldEnabled
        ? 'O Trader Shield está ativo'
        : 'O Trader Shield foi desativado',
      type: NotificationTypes.success
    });
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Houve um problema ao ativar/desativar o Trader Shield. Tente novamente em breve.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
    emit('close');
  }
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,emit, props, marginAllocation, fetchMarginAllocation, isLoading, isPasswordModalOpen, helperViewClass, title, description, traderShieldDetails, confirmPassword, handleTraderShield, NavBar, HelperViewContextual, HeadingDisplay, InitialAvatarIcon, Heading, BaseText, Row, ButtonContainer, ButtonPrimary, SideSheet, BackButton, PasswordModal }
}

})